import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import AccountsTab from 'components/tabs/AccountsTab';

const CompanyAccountsTab = (props) => (
  <SimpleShowLayout>
    <AccountsTab target="company_id" {...props} />
  </SimpleShowLayout>
);

export default CompanyAccountsTab;
